const actions = {
  SET_LICENSE_LIST: 'SET_LICENSE_LIST',
};

export default actions;
